import React, { Component } from "react";
import { getRedditListing } from "./../../services/redditService";
import _ from "underscore";
import "./index.css";

class SocialReddit extends Component {
  state = {
    redditList: []
  };

  async componentDidMount() {
    await getRedditListing().then(res => {
      const redditJson = res.data;
      const posts = redditJson.data.children.map(obj => obj.data);
      this.setState({
        redditList: posts
      });
    });
  }

  render() {
    return (
      <div className="row mt-4">
        <div className="col">
          <div
            className="reddit-col  p-3"
            style={{
              background: "var(--cardBg)",
              border: "var(--card-border)",
              transition: "color 0.2s ease-out, background 0.2s ease-out"
            }}
          >
            <div className="market-inner-col d-flex justify-content-between mb-3">
              <span className="badge badge-warning market-bedge">
                SOCIAL REDDIT
              </span>
              <img
                className="img-fluid"
                src={require("../../assets/icons/share-icon.svg")}
                alt="share"
              />
            </div>

            <div className="social-reddit-link">
              <p style={{ color: "var(--pColor)" }}>
                links from{" "}
                <a
                  href="https://tauchain.reddit.com"
                  style={{ color: "var(--a)" }}
                >
                  tauchain.reddit.com
                </a>
              </p>
            </div>

            {this.state.redditList.slice(0, 4).map((redditpost, index) => (
              <div className="row" key={index}>
                <div className="col-2 text-center p-0">
                  <div className="row">
                    <div className="col-12 p-0">
                      <img
                        className="img-fluid"
                        src={require("../../assets/icons/up-arrow.svg")}
                        alt="up-arrow"
                        style={{ filter: "var(--reddit-up-down-arrows)" }}
                      />
                    </div>
                    <div className="col-12 p-0">
                      <img
                        className="img-fluid reddit-down-arrow"
                        src={require("../../assets/icons/down-arrow-2.svg")}
                        alt="up-arrow"
                        style={{ filter: "var(--reddit-up-down-arrows)" }}
                      />
                    </div>
                  </div>
                </div>
                <div className="col-10 p-0">
                  <div className="social-reddit-post-wrap">
                    <a
                      className="social-reddit-posts mb-0"
                      href={redditpost.url}
                      style={{ color: "var(--a)" }}
                      target="_blank"
                    >
                      <span className="posts-title">{redditpost.title} </span>
                    </a>
                    <p
                      className="social-reddit-feedback"
                      style={{ color: "var(--pColor)" }}
                    >
                      <span className="reddit-points">
                        {redditpost.score} points
                      </span>
                      <span> | </span>
                      <span className="reddit-comments">
                        {redditpost.num_comments} comments
                      </span>
                    </p>
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    );
  }
}

export default SocialReddit;
